<template>
  <div>
    <vxe-grid
      ref="table"
      size="small"
      row-id="custContactCode"
      :border="false"
      auto-resize
      highlight-hover-row
      :height="500"
      :data="tableData"
      :columns="tableColumns"
      :loading="loading"
      :radio-config="{ highlight: true, trigger: 'row' }"
      @radio-change="radioChange"
    >
      <template v-slot:empty="{}">
        <div style="text-align: center">
          <img src="/image/static/img/nodata.png" />
          <p class="no-data">
            {{ $l('INDEX.tips_no_data') || '暂无数据！' }}
          </p>
        </div>
      </template>
    </vxe-grid>
  </div>
</template>
<script>
import tableColumns from './table-columns'
export default {
  props: {
    tableData: { type: Array, default: () => [] },
    loading: { type: Boolean, default: false },
  },
  data() {
    return { tableColumns: tableColumns(this) }
  },
  methods: {
    radioChange({ row }) {
      this.$emit('radio-change', row)
    },
  },
}
</script>
